import { useAuth0 } from "@auth0/auth0-react";

import API_Call_Handler from "@/api/API_Call_Handler";

export default function API_Calls_Utils() {
  const { getAccessTokenSilently } = useAuth0();
  const { apiCall } = API_Call_Handler();

  async function queryParamsAndHeaders(
    paramsObject,
    managementToken = null,
    formData = false
  ) {
    // CREATE QUERY STRING
    if (Object.hasOwn(paramsObject, "affiliate")) {
      paramsObject["affiliate"] = paramsObject["affiliate"].toUpperCase();
    }
    const queryParams = { ...paramsObject };
    const queryString = new URLSearchParams(queryParams).toString();
    // END CREATE QUERY STRING

    //CREATE HEADERS
    const token = await getAccessTokenSilently();
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    headers["Content-Type"] = !formData
      ? "application/json; charset=UTF-8"
      : "multipart/form-data; boundary=gc0p4Jq0M2Yt08jU534c0p";
    if (managementToken) {
      headers["X-Mgmt-authorization"] = `Bearer ${managementToken}`;
    }
    //END CREATE HEADERS

    return { headers, queryString };
  }

  async function getManagementTokenHeaders() {
    const token = await getAccessTokenSilently();
    const headers = {
      Authorization: `Bearer ${token}`,
      ContentType: "application/x-www-form-urlencoded",
    };
    return { headers };
  }

  async function handlePresignedUrlDownload(
    url,
    headers,
    method = "GET",
    data
  ) {
    const presignedUrlResponse = await apiCall({
      url,
      headers,
      method,
      data,
    });

    if (presignedUrlResponse.error) {
      return { error: true };
    } else {
      window.open(presignedUrlResponse.data.download_link, "_blank");
      return { error: false };
    }
  }

  return {
    queryParamsAndHeaders,
    getManagementTokenHeaders,
    handlePresignedUrlDownload,
  };
}
